/**
 * @file index.tsx
 *
 * @fileoverview This component will make the window scroll to it when rendered.
 */

import React, { createRef, useEffect } from 'react';

export interface ScrollToELementProps {
  /**
   * The content to be displayed.
   */
  children: React.ReactNode;
}

export const ScrollToElement = ({ children }: ScrollToELementProps) => {
  const ref: any = createRef();
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, []); // Run only once.
  return <div ref={ref}>{children}</div>;
};
